import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Loading from '../PrivacyPolicy/Loading';
import { useLanguage } from '../../store/language-context';
import { useTranslation } from 'react-i18next';
import getToken from '../../hooks/getToken';
import { useNavigate } from 'react-router-dom';

const PackageManager = () => {
  const { URL } = useLanguage();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const token = getToken();

  const [loading, setLoading] = useState(false);
  const [packageData, setPackageData] = useState(null);
  const [formData, setFormData] = useState({
    package_name: '',
    service_id: ''
  });
  const [updateStatus, setUpdateStatus] = useState('');
  const [error, setError] = useState('');

  // أسماء الحزم الثابتة
  const packageNames = t('profile.packages', { returnObjects: true })

  // جلب بيانات الحزمة عند تحميل المكون
  useEffect(() => {
    const fetchPackage = async () => {
      setLoading(true);

      if (!token) {
        navigate('/login');
        return;
      }

      try {
        const response = await axios.get(`${URL}/packages`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });

        if (response.status === 200 && response.data.data) {
          setPackageData(response.data.data);
          setFormData({
            package_name: response.data.data.package_name || '',
            service_id: '7'
          });
        }
      } catch (err) {
        setError(err?.response?.data?.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPackage();
  }, [URL]);

  // التعامل مع تغيير قيم الحقول
  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  // إرسال تحديث الحزمة
  const handleUpdate = async (e) => {
    e.preventDefault();

    if (!token) {
      navigate('/login');
      return;
    }

    try {
      const response = await axios.post(
        `${URL}/packages/update`,
        {
          package_name: formData.package_name,
          service_id: formData.service_id
        },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      if (response.status === 200) {
        setUpdateStatus(t('custom.done'));
      } else {
        setUpdateStatus(t('custom.failed'));
      }
    } catch (err) {
      setUpdateStatus(err?.response?.data?.message);
    }
  };

  return (
    <div className='p-2 mt-4'>
      <h3 className='text-center mb-4'>{t('profile.pack-name-2')}</h3>

      {loading ? (
        <Loading />
      ) : error ? (
        <p className="text-danger">
          {typeof error === 'string' ? error : 'حدث خطأ في النظام'}
        </p>
      ) : packageData ? (
        <form onSubmit={handleUpdate} style={{ width: '100%', textAlign: 'right' }}>
          <div style={{ margin: '16px 0', backgroundColor: "#F5F5F5", borderRadius: "12px", padding: "16px 24px" }}>
            <label style={{ display: 'block', marginBottom: '8px', color: '#6A2F38', fontWeight: 'bold' }}>{t('profile.pack-name-3')}</label>
            <select
              name="package_name"
              value={formData.package_name}
              onChange={handleChange}
              style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
            >
              <option value="" disabled>{t('profile.choose-pack')}</option>
              {packageNames.map((name) => (
                <option key={name} value={name} className='package-name'  >
                  {name}
                </option>
              ))}
            </select>

            <div className='text-center mt-4'>
              <label style={{ display: 'block', marginBottom: '8px', color: '#6A2F38', fontWeight: 'bold' }}>
                {t('profile.pack-name')}
              </label>
              <span style={{ display: 'block', width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc', background: '#fff' }}>
                {t('profile.pack-name-2')}
              </span>
            </div>
          </div>

          <button type="submit" style={{ display: 'block', margin: '20px auto', backgroundColor: "#6A2F38", color: "#fff", padding: "8px 16px", border: "none", borderRadius: "4px" }}>
            {t('profile.update-pack')}
          </button>
        </form>
      ) : (
        <p>{t('profile.no-packages')}</p>
      )}

      {updateStatus && (
        <p style={{ color: '#6A2F38', textAlign: 'center', marginTop: '10px' }}>
          {typeof updateStatus === 'string' ? updateStatus : t('custom.err')}
        </p>
      )}
    </div>
  );
};

export default PackageManager;